var Methods;
(function (Methods) {
    Methods["GET"] = "GET";
    Methods["POST"] = "POST";
    Methods["DELETE"] = "DELETE";
    Methods["PUT"] = "PUT";
    Methods["PATCH"] = "PATCH";
})(Methods || (Methods = {}));
export default Methods;
